import Auth from '@/helpers/authorizations'

export default {
  computed: {
    /**
     * 允许的权限
     *
     * @returns {Array<string>} 路由及权限信息
     */
    permittedAuthCodes() {
      return this.$store.state.app.permittedAuthorizations
    }
  },
  methods: {
    /**
     * 用于显示菜单，当子菜单存在访问权限时，显示该菜单节点
     *
     * @param {Array<object>} menuSubItems 子菜单列表
     * @param {Array<string>} permittedAuthCodes 允许的权限代码
     * @returns {boolean} 是否能访问指定的菜单
     */
    canAccessMenus(menuSubItems, permittedAuthCodes) {
      return menuSubItems.some(menuItem => {
        return this.canAccess(menuItem, menuItem.authCode, permittedAuthCodes)
      })
    },
    /**
     * 是否能访问
     *
     * @param {object} menu 菜单的定义
     * @param {string} authCode 需要判断的权限
     * @param {Array<string>} permittedAuthCodes 允许的权限代码
     * @returns {boolean} 是否允许
     */
    canAccess(menu, authCode, permittedAuthCodes) {
      if (authCode === undefined) {
        console.log('Undefined menu auth code: ', menu.name)
      }
      return authCode === Auth.common || (permittedAuthCodes && permittedAuthCodes.some(permittedAuthCode => permittedAuthCode === authCode))
    }
  }
}
